<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full" style="cursor: pointer;">
                <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Copyright Information</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightFormsEscalated :application="application" v-if="currentRoute === 'forms'"/>
              <CopyrightFormFilesEscalated :application="application" v-if="currentRoute === 'attachments'"/>
              <CopyrightMessagesEscalated :application="application" v-if="currentRoute === 'messages'"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CopyrightFormsEscalated
  from "@/views/home/services/copyright/escalations/tabs/CopyrightFormsEscalated.vue";
import CopyrightFormFilesEscalated
  from "@/views/home/services/copyright/escalations/tabs/CopyrightFormFilesEscalated.vue";
import CopyrightMessagesEscalated
  from "@/views/home/services/copyright/escalations/tabs/CopyrightMessagesEscalated.vue";
export default {
  name: "CopyrightFormDetailsEscalated",
  components: {
    CopyrightMessagesEscalated,
    CopyrightFormFilesEscalated,
    CopyrightFormsEscalated,
  },
  props:{
    application:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
